<div class="container">
  @switch (BANNER_TYPE[bannerType()].type) {
    <!-- SUCCESS BANNER-->
    @case (BANNER_MESSAGE_TYPE.SUCCESS) {
      <div class="background-success">
        <ion-icon class="icon" [src]="IMAGES.BANNER_SUCCESS"></ion-icon>
        <div class="text">{{ BANNER_TYPE[bannerType()].text }}</div>
        <ion-icon
          class="icon"
          alt="close"
          onkeypress="clickExit()"
          [src]="IMAGES.CLOSE_BLACK"
          (click)="clickExit()"
        ></ion-icon>
      </div>
    }
    <!-- CAUTION BANNER-->
    @case (BANNER_MESSAGE_TYPE.CAUTION) {
      <div class="background-caution">
        <ion-icon class="icon" [src]="IMAGES.CAUTION"></ion-icon>
        <div class="text">{{ BANNER_TYPE[bannerType()].text }}</div>
        <ion-icon
          class="icon"
          alt="close"
          onkeypress="clickExit()"
          [src]="IMAGES.CLOSE_BLACK"
          (click)="clickExit()"
        ></ion-icon>
      </div>
    }
    <!-- FAIL BANNER-->
    @case (BANNER_MESSAGE_TYPE.FAIL) {
      <div class="background-fail">
        <ion-icon class="icon-fail" [src]="IMAGES.BANNER_FAIL"></ion-icon>
        <div class="text">{{ BANNER_TYPE[bannerType()].text }}</div>
        <ion-icon
          class="icon"
          alt="close"
          onkeypress="clickExit()"
          [src]="IMAGES.CLOSE_BLACK"
          (click)="clickExit()"
        ></ion-icon>
      </div>
    }
    <!-- GENERIC 400 BANNER-->
    @case (BANNER_MESSAGE_TYPE.FAIL_400) {
      <div class="background-fail">
        <ion-icon class="icon-fail" [src]="IMAGES.BANNER_FAIL"></ion-icon>
        <div class="text">
          {{
            BANNER_TYPE[bannerType()].text.replace("%s", BANNER_400_MESSAGE())
          }}
        </div>
        <ion-icon
          class="icon"
          alt="close"
          onkeypress="clickExit()"
          [src]="IMAGES.CLOSE_BLACK"
          (click)="clickExit()"
        ></ion-icon>
      </div>
    }
  }
</div>
